import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkdownComponent } from 'ngx-markdown';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { map, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ProductConfigurationService } from '@fleet/product-configuration';

@Component({
  selector: 'fleet-change-log',
  standalone: true,
  imports: [CommonModule, MarkdownComponent],
  template: `
    <div
      class="prose max-w-none"
      style="margin: 0 auto; max-width: 800px; padding: 20px"
    >
      <img [src]="logoSrc" alt="Logo" class="h-10 mx-auto mb-10" />
      <markdown
        [data]="changelogContent$ | async"
        ngPreserveWhitespaces
        emoji
      ></markdown>
      <style>
        h1 {
          @apply my-16;
        }
        h2 {
          margin-top: 25px;
          margin-bottom: 12px;
        }
        h3 {
          margin-top: 20px;
          margin-bottom: 10px;
        }
      </style>
    </div>
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangeLogComponent {
  changelogContent$: Observable<string>;
  logoSrc: string;
  brandConfig: any;
  fleetLogo =
    'data:image/svg+xml;base64,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';

  constructor(
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private productConfigurationService: ProductConfigurationService
  ) {
    this.changelogContent$ = this.productConfigurationService.config$.pipe(
      takeUntilDestroyed(),
      switchMap((config: any) => {
        this.brandConfig = config;
        this.logoSrc = this.brandConfig.horizontalLogo;
        this.logoSrc = this.fleetLogo;
        this.cdr.markForCheck();
        return this.http.get('assets/CHANGELOG.md', { responseType: 'text' });
      }),
      map((content) => this.clearLinks(content))
      // map((content) => this.addLogoToHeader(content))
    );
  }

  private clearLinks(releaseNotes: string): string {
    // Regex to remove compare links but preserve the version number (e.g., [2.3.5](...))
    const compareLinkRegex = /\[([\d.]+)\]\(.*?\)/g;
    // Regex to remove commit links (e.g., [hash](...) or ([hash](...)))
    const commitLinkRegex = /\(\[.*?\]\(.*?\)\)/g;

    // Regex to remove Jira references (e.g., closes [#FW-1566](...))
    const jiraLinkRegex = /, closes \[#\w+-\d+\]\(.*?\)/g;

    // Remove compare links but keep the version numbers
    let cleanedNotes = releaseNotes.replace(compareLinkRegex, '$1');
    // Remove commit links and the surrounding parentheses entirely
    cleanedNotes = cleanedNotes.replace(commitLinkRegex, '');
    cleanedNotes = cleanedNotes.replace(jiraLinkRegex, '');
    return cleanedNotes;
  }

  private addLogoToHeader(releaseNotes: string): string {
    const logoMarkdown = `![Logo](${this.logoSrc})\n`;
    return releaseNotes.replace(
      /^#\s+Fleet\s+-\s+release\s+notes/,
      `${logoMarkdown}# Fleet - release notes`
    );
  }
}
